import { render, staticRenderFns } from "./NotificationWithActions.vue?vue&type=template&id=0fb60f7f&scoped=true&"
import script from "./NotificationWithActions.vue?vue&type=script&lang=js&"
export * from "./NotificationWithActions.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWithActions.vue?vue&type=style&index=0&id=0fb60f7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb60f7f",
  null
  
)

export default component.exports